import {Environment} from '@eitje/api'

export const EnvironmentCell = ({getValue}) => {
	const environment = Environment.useFind(getValue())
	return environment.naam || null
}
